import { Config } from './types';

export const config: Config = {
  appUrl: 'https://lt.elmenus.com', // TODO: to be fixed once we have prod env url
  appEnv: 'prod',
};
